import { useI18n } from '@cascade/react/i18n';
import { TermsGate as SharedTermsGate } from '@cascade/react/terms';
import type { PropsWithChildren } from 'react';
import { Layout } from '#layout/index.ts';
import { Terms } from '#views/terms/index.ts';

export const TermsGate = ({ children }: PropsWithChildren) => {
  const { translate } = useI18n();

  return (
    <SharedTermsGate
      loading={
        <Layout mode='card' title={translate('pending.terms')} isLoading />
      }
      unaccepted={<Terms />}
    >
      {children}
    </SharedTermsGate>
  );
};
